// Blog configuration
export const BLOG_CONFIG = {
  POSTS_PER_PAGE: 3,
  RECENT_POSTS_COUNT: 3,
  CACHE_DURATION: 60 * 60 * 1000, // 1 hour
}

export default BLOG_CONFIG